const ExperienceData = [
  {
    title: "CI/CD Pipeline Engineering",
    company: "DevOps Capabilities",
    duration: "Design • Build • Automate",
    description: [
      "Designed and implemented automated CI/CD pipelines using Jenkins, GitHub Actions, and GitLab CI.",
      "Standardized build, test, security scanning, and deployment workflows.",
      "Improved deployment reliability and reduced manual effort through automation-first practices."
    ],
  },
  {
    title: "GitOps & Kubernetes Delivery",
    company: "Cloud-Native & Platform Engineering",
    duration: "Kubernetes • GitOps • Helm",
    description: [
      "Implemented GitOps-based continuous delivery using ArgoCD with Git as the single source of truth.",
      "Managed Kubernetes application deployments using Helm charts and containerized workloads.",
      "Enabled controlled, repeatable, and environment-consistent deployments."
    ],
  },
  {
    title: "DevSecOps & Cloud Security",
    company: "Security-Integrated DevOps",
    duration: "Shift-Left Security",
    description: [
      "Integrated security and quality checks into CI/CD pipelines using Trivy, OWASP dependency scanning, and SonarQube.",
      "Applied shift-left security practices for early vulnerability detection.",
      "Balanced security controls with deployment speed and developer productivity."
    ],
  },
  {
    title: "Observability & Reliability",
    company: "Monitoring & Reliability Engineering",
    duration: "Metrics • Monitoring • Alerts",
    description: [
      "Implemented monitoring and observability using Prometheus and Grafana.",
      "Configured dashboards and alerts to track system health and performance.",
      "Focused on reliability, visibility, and proactive issue detection."
    ],
  },
];

export default ExperienceData;
